export const FootnoteSymbols = {
  excludedInvestments: '*',
  customMetrics: '†',
  vennModifiedData: '‡',
  pgaRank: '*',
  proxyUsage: '§',
} as const;
